(function () {
    window.LBSApp = window.LBSApp || {};
    window.LBSApp.Components = window.LBSApp.Components || {};
    
    window.LBSApp.Components.ProductPicker = function (element) {
        const selectElement = element.querySelector('.product-picker__dropdown');
        const form = element.querySelector('.product-picker__form');
        
        if (!selectElement) {
            console.warn('ProductPicker: dropdown element not found');
            return;
        }
        
        function handleChange() {
            const selectedOption = selectElement.options[selectElement.selectedIndex];
            const url = selectElement.value;            
            window.location.href = url;
        }
        
        function initEventListeners() {
            selectElement.addEventListener('change', handleChange);
            
            // Prevent form submission when navigating via JS
            if (form) {
                form.addEventListener('submit', function(e) {
                    e.preventDefault();
                });
            }
        }
        
        function init() {
            initEventListeners();
        }
        
        init();
    };
})();
